// extracted by mini-css-extract-plugin
module.exports = {"scoreboard":"Scores_scoreboard__16IXw"};